import { SelectProps } from '@ui-system/interfaces-form';

const defaultProps: Partial<SelectProps> = {
  disabled: false,
};

export default defaultProps;
